import Vue from "vue";
// import store from "@/store"
import draggable from "vuedraggable";
import Properties from "@/components/form_elements_sentences/properties/Properties.vue";

import FormElementTitle from "@/components/form_elements_sentences/formElements/FormElementTitle";
import FormElementExplain from "@/components/form_elements_sentences/formElements/FormElementExplain";
import FormElementExample from "@/components/form_elements_sentences/formElements/FormElementExample";
import FormElementIllustration from "@/components/form_elements_sentences/formElements/FormElementIllustration";
import FormElementStructure from "@/components/form_elements_sentences/formElements/FormElementStructure";
import FormElementChallenge from "@/components/form_elements_sentences/formElements/FormElementChallenge";
import vm from "@/main";

export const FormBuilder = new Vue({
  components: {
    draggable,
    Properties,
    FormElementTitle,
    FormElementExplain,
    FormElementExample,
    FormElementIllustration,
    FormElementStructure,
    FormElementChallenge,
  },
  data() {
    return {
      fields: [
        {
          fieldType: "FormElementTitle",
          type: "text",
          text: "タイトル",
          key: "Title",
          disabled: true,
          require: false,
          id: "",
          value: {},
          isType: "TEXT",
          alignItems: "center",
          color: "#69BE5B",
        },
        {
          fieldType: "FormElementExplain",
          type: "text",
          text: "説明",
          key: "Explain",
          disabled: true,
          require: false,
          id: "",
          value: {},
          cols: 12,
        },
        {
          fieldType: "FormElementExample",
          type: "text",
          text: "例文",
          key: "Example",
          disabled: true,
          require: false,
          id: "",
          value: {},
          file: null,
          cols: 12,
        },
        {
          fieldType: "FormElementIllustration",
          type: "image",
          text: "挿絵データ",
          key: "Illustration",
          disabled: true,
          require: false,
          id: "",
          file: null,
          cols: 12,
        },
        {
          fieldType: "FormElementStructure",
          type: "button",
          text: "文構造",
          key: "Structure",
          disabled: true,
          require: false,
          id: "",
          isType: "BOX",
          alignItems: "center",
          value: {},
          width: 2,
          color: "#69BE5B",
        },
        {
          fieldType: "FormElementChallenge",
          type: "text",
          text: "チャレンジ文",
          key: "Challenge",
          disabled: true,
          require: false,
          id: "",
          value: {},
          cols: 12,
        },
      ],
    };
  },
  methods: {
    deleteElement(index, form) {
      this.$delete(form, index);
      vm.$store.activeFieldExpression = {};
    },

    cloneElement(index, field, form, fieldsDefaultID) {
      var cloned = this._.cloneDeep(field); // clone deep lodash
      cloned.id = `${fieldsDefaultID}`;
      form.splice(index + 1, 0, cloned);
      this.editElementProperties(cloned);
    },

    editElementProperties(field) {
      vm.$store.activeFieldExpression = field;
    },
  },
});
